const COLORS = {
  Low: "#19bc31",
  Moderate: "#ff9500",
  High: "#ff4343",
};

export default function RiskBadge({ level }) {
  const color = COLORS[level] || "#a1a0a0";
  return (
    <span
      className="badge rounded-pill"
      style={{ background: color, color: "#fff", fontSize: 11, fontWeight: 600 }}
    >
      {level} risk
    </span>
  );
}
